import { render, staticRenderFns } from "./NUTRIC.vue?vue&type=template&id=2023bdc2&scoped=true"
import script from "./NUTRIC.vue?vue&type=script&lang=js"
export * from "./NUTRIC.vue?vue&type=script&lang=js"
import style0 from "./NUTRIC.vue?vue&type=style&index=0&id=2023bdc2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2023bdc2",
  null
  
)

export default component.exports